<template>
  <v-card class="px-2 py-2 mb-2">
    <v-tabs
      v-model="tabs"
      height="34"
      background-color="#fafafa"
    >
      <v-tab
        class="text-overline"
        v-for="(item, index) in cargoTabsArr"
        :key="index"
      >
        {{ $t('m.cargo') + ' - ' + (index + 1) }}
      </v-tab>

      <div class="ml-8 mt-1">
        <v-btn
          x-small
          outlined
          dark
          color="teal"
          @click="handleAddNew"
          v-if="!isRotating"
        >
          <v-icon small>
            mdi-plus
          </v-icon>
        </v-btn>
        <v-btn
          x-small
          outlined
          dark
          color="purple"
          class="ml-4"
          @click="handleRemoveItem"
          v-if="cargoTabsArr.length>1 && !isRotating"
        >
          <v-icon small>
            mdi-minus
          </v-icon>
        </v-btn>
      </div>
    </v-tabs>

    <v-tabs-items v-model="tabs">
      <v-tab-item
        v-for="(item, index) in cargoTabsArr"
        :key="index"
      >
        <CargoItemForm
          :form="item"
          :index="index"
          :model="model"
          :edit-flag="editFlag"
          :key="index"
        />
      </v-tab-item>
    </v-tabs-items>

    <v-snackbar
      centered
      v-model="snackbar"
    >
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn
          color="pink"
          text
          v-bind="attrs"
          @click="snackbar = false"
        >
          {{ $t('m.close') }}
        </v-btn>
      </template>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import Utils from '@/utils/index'
import httpClient from '@/api/httpClient'
import Constant from '@/constant'
import EstiTmpl from '@/components/estimation/EstiTmpl'
import CargoItemForm from '@/components/estimation/CargoItemForm'

export default {
  name: 'CargoPane',
  components: { CargoItemForm },
  props: [
    'editFlag', 'model'
  ],
  data () {
    return {
      tabs: null,
      snackbar: false,
      snackbarText: null,
      cargoTabsArr: [this._.cloneDeep(EstiTmpl.CARGO_FORM)]
    }
  },
  created () {
    this.$store.commit('setIsRotating', false)
    this.$store.commit('setEstiIsGettedDistance', false)
  },
  mounted () {
  },
  computed: {
    ...mapState({
      isRotating: state => state.estimating.isRotating,
      isGettedDistance: state => state.estimating.isGettedDistance,
      resetMessage: state => state.estimating.resetMessage,
      clearFlag: state => state.estimating.clearFlag
    }),
    ...mapGetters({
      ttlIncome: 'getTtlIncome'
    })

  },
  watch: {
    model: function (val) {
      if (val) {
        this.resetForm()
      } else {
        this.clearForm()
      }
    },

    clearFlag: function (val) {
      if (val) this.clearForm()
    },

    tabs: function (val) {
    }
  },
  methods: {
    handleAddNew () {
      var _this = this
      if (!this.checkCargos()) {
        this.snackbarText = this.$t('m.inputCargoAndPort')
        this.snackbar = true
        return
      }

      const cargoItem = this._.cloneDeep(EstiTmpl.CARGO_FORM)
      this.cargoTabsArr.push(cargoItem)
      this.$store.commit('setCargoTabArr', this.cargoTabsArr)
      this.tabs = this.cargoTabsArr.length - 1
    },

    checkCargos () {
      for (var i = 0; i < this.cargoTabsArr.length; i++) {
        if (this._.trim(this.cargoTabsArr[i].Cargo) === '' ||
              this.cargoTabsArr[i].LoadPort.portId.length == 0 ||
              this.cargoTabsArr[i].DischargePort.portId.length == 0) {
          return false
        }
      }
      return true
    }, // end checkCargos

    handleRemoveItem () {
      if (this.isRotating === true) {
        return
      }
      this.cargoTabsArr.splice(this.tabs, 1)
      this.$store.commit('removeCargoTab', this.tabs)
    },

    clearForm () {
      this.cargoTabsArr = [this._.cloneDeep(EstiTmpl.CARGO_FORM)]
      this.$store.commit('setCargoTabArr', this.cargoTabsArr)
    },

    resetForm () {
      if (this.model.ESTICONTENT.cargoData.length > 0) {
        var cargoForm; var willArr = []

        for (var i = 0; i < this.model.ESTICONTENT.cargoData.length; i++) {
          cargoForm = this._.cloneDeep(this.model.ESTICONTENT.cargoData[i])
          cargoForm.Income = cargoForm.Revenue //
          if (cargoForm.AddCommRate < 0.1) {
            cargoForm.AddCommRate = cargoForm.AddCommRate * 100
          }
          if (cargoForm.BrokerageRate < 0.1) {
            cargoForm.BrokerageRate = cargoForm.BrokerageRate * 100
          }
          if (cargoForm.FrtTaxRate < 0.1) {
            cargoForm.FrtTaxRate = cargoForm.FrtTaxRate * 100
          }

          cargoForm.LoadPort = {}
          cargoForm.DischargePort = {}

          cargoForm.LoadPort.portId = cargoForm.From
          cargoForm.LoadPort.fullName = cargoForm.FromName
          // cargoForm.LoadPort.longitude = cargoForm.lon

          cargoForm.DischargePort.portId = cargoForm.To
          cargoForm.DischargePort.fullName = cargoForm.ToName

          willArr.push(cargoForm)
        } // end for

        this.cargoTabsArr = willArr
        this.$store.commit('setCargoTabArr', this.cargoTabsArr)
        this.tabs = 0
      } // end update
      else {
        this.clearForm()
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>
